import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../components/LanguageContext';
import './components.css';

const Form = () => {
  const { language, translations } = useLanguage();
  const formRef = useRef(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const TOKEN = "7772542841:AAF5jcRWlwVCk5ZHtOAGaY1et4yWDS8X5Vs";
  const CHAT_ID = "-1002345632637";
  const URI_API = `https://api.telegram.org/bot${TOKEN}/sendMessage`;

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = formRef.current;
    const t = translations['formTranslations.json']?.form || {};
    let message = `<b>${t.telegram_message_title?.[language] || 'Заявка з сайту!'}</b>\n`;
    message += `<b>${t.fields?.name?.label?.[language] || 'Ім\'я'}: </b>${form.name.value}\n`;
    message += `<b>${t.fields?.phone?.label?.[language] || 'Телефон'}: </b>${form.phone.value}\n`;
    message += `<b>${t.fields?.email?.label?.[language] || 'Пошта'}: </b>${form.email.value}\n`;
    message += `<b>${t.fields?.company?.label?.[language] || 'Компанія'}: </b>${form.company.value}\n`;
    message += `<b>${t.fields?.message?.label?.[language] || 'Повідомлення'}: </b>${form.message.value}\n`;

    axios
      .post(URI_API, { chat_id: CHAT_ID, parse_mode: 'html', text: message })
      .then(() => {
        form.reset();
        setIsSubmitted(true);
        setIsChecked(false);
      })
      .catch((error) => console.error('Помилка відправки повідомлення до Telegram:', error));
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const t = translations['formTranslations.json']?.form || {};

  const renderTextWithStyles = (text) => {
    if (!text) return null;
    const keywords = ['Education', 'Experience', 'Languages', 'Location'];
    return text.split('\n').map((line, index, array) => {
      const parts = line.split(new RegExp(`(${keywords.join('|')})`, 'g')).map((part, i) => {
        if (keywords.includes(part)) {
          return <span key={i} style={{ fontWeight: 700 }}>{part}</span>;
        }
        return part;
      });
      return (
        <React.Fragment key={index}>
          {parts}
          {index < array.length - 1 && <br />}
        </React.Fragment>
      );
    });
  };

  return (
    <div className="form_container">
      <h1 className="form_title">{t.title?.[language] || 'Contact Us'}</h1>
      <div className="form_item">
        <h2>{t.subtitle?.[language]}</h2>
        {isSubmitted ? (
          <div className="form_thank-you">
            <h3>{t.thank_you?.title?.[language]}</h3>
            <p>{renderTextWithStyles(t.thank_you?.description?.[language])}</p>
          </div>
        ) : (
          <form ref={formRef} onSubmit={handleSubmit} id="orderForm">
            <input
              type="text"
              name="name"
              placeholder={t.fields?.name?.placeholder?.[language]}
              className="form_input"
            />
            <input
              type="tel"
              name="phone"
              placeholder={t.fields?.phone?.placeholder?.[language]}
              className="form_input"
            />
            <input
              type="email"
              name="email"
              placeholder={t.fields?.email?.placeholder?.[language]}
              className="form_input"
            />
            <input
              type="text"
              name="company"
              placeholder={t.fields?.company?.placeholder?.[language]}
              className="form_input"
            />
            <textarea
              name="message"
              placeholder={t.fields?.message?.placeholder?.[language]}
              className="form_textarea"
              rows="5"
            ></textarea>
            <div className="check_link-item">
              <div className="input_item">
                <input
                  type="checkbox"
                  id="agreement"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="agreement" className="custom-checkbox"></label>
              </div>
              <Link to="/privacy-policy">
                {t.agreement?.[language] || 'I consent to the processing of personal data and accept the privacy terms'}
              </Link>
            </div>
            <button
              type="submit"
              className="form_button"
              disabled={!isChecked}
              style={{ opacity: isChecked ? 1 : 0.5 }}
            >
              {t.button?.[language]}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Form;